import { grid } from '@app/components/package-customize/customize-sheet-item/sheet/utils';

export default {
  nameDesc: '4 - 3x5',
  imageCount: 4,
  displayGroup: 'DG_3X5',
  calc: (height) => grid(2, 2, height)
};
